import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-hr-action-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule],
  templateUrl: './hr-action-dialog.component.html',
  styleUrls: ['./hr-action-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HrActionDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() title = '';
  @Input() eyebrow = 'HR Action';
  @Input() subtitle = '';
  @Input() icon = 'fa-solid fa-pen-to-square';
  @Input() contextTitle = '';
  @Input() contextSubtitle = '';
  @Input() width = 'min(980px, 94vw)';
}
